import type { DisplayMarketingCampaign } from "@common/interfaces/KYDMarketing";
import { PublisherPlatforms } from "@common/interfaces/KYDMarketing";

/** Unique Facebook page ids referenced by ad creatives (for IG account fetch). */
export function collectFacebookPageIdsFromCampaign(
  campaign: DisplayMarketingCampaign | null | undefined
): string[] {
  const ids = new Set<string>();
  for (const adset of campaign?.adsets ?? []) {
    for (const ad of adset.ads ?? []) {
      const cp =
        ad.creative?.identity?.[PublisherPlatforms.facebook]?.page_id?.trim();
      if (cp) ids.add(cp);
    }
  }
  return Array.from(ids);
}

/** First advertiser page + Instagram actor on the campaign, for partnership catalog loads. */
export function collectAdvertiserIdentityFromCampaign(
  campaign: DisplayMarketingCampaign | null | undefined
): { pageId?: string; instagramUserId?: string } {
  for (const adset of campaign?.adsets ?? []) {
    for (const ad of adset.ads ?? []) {
      const identity = ad.creative?.identity;
      const pageId =
        identity?.[PublisherPlatforms.facebook]?.page_id?.trim() || undefined;
      const instagramUserId =
        identity?.[PublisherPlatforms.instagram]?.instagram_actor_id?.trim() ||
        undefined;
      if (pageId || instagramUserId) {
        return { pageId, instagramUserId };
      }
    }
  }
  return {};
}
